import { render, staticRenderFns } from "./AdminUnhealthyDevices.vue?vue&type=template&id=25826c84&scoped=true&"
import script from "./AdminUnhealthyDevices.vue?vue&type=script&lang=js&"
export * from "./AdminUnhealthyDevices.vue?vue&type=script&lang=js&"
import style0 from "./AdminUnhealthyDevices.vue?vue&type=style&index=0&id=25826c84&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25826c84",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25826c84')) {
      api.createRecord('25826c84', component.options)
    } else {
      api.reload('25826c84', component.options)
    }
    module.hot.accept("./AdminUnhealthyDevices.vue?vue&type=template&id=25826c84&scoped=true&", function () {
      api.rerender('25826c84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/AdminUnhealthyDevices.vue"
export default component.exports